export default {
  firstPart: {
    title: "阿朗终端ALE Device M8桌面话机",
    soon: "即将上市，敬请期待",
    day: "天",
    hour: "时",
    min: "分",
    sec: "秒",
    MoreThanPhone: "不止于通话",
    moreInfo: "更多信息",
  },
  secondPart: {
    tabs1: "产品亮点",
    tabs2: "应用场景",
    features1: {
      title: "让商务连接更简单",
      desc: "畅享全新工作生活方式",
      img1: "顺畅沟通交流",
      img2: "无缝同步连接",
      img3: "提升用户体验",
      img4: "更快速更强劲",
      img5: "随时随地开会",
    },
    features2: {
      title: "高端智能商务设计",
      desc: "",
      text1: "5英寸IPS彩色大屏",
      text2: "灵敏触控按钮",
    },
    features3: {
      title: "比高清更清晰",
      desc: "",
      text1: "超宽带音频",
    },
    features4: {
      title: "沉浸体验，灵活沟通",
      desc: "",
      text1: "360°全向拾音",
    },
    features5: {
      title: "丰富连接方式，轻松同步通讯",
      desc: "",
      text1: "支持双频Wi-Fi (2.4/5G)",
      text2: "支持蓝牙5.0",
    },
    features6: {
      title: "强劲性能，快速高效",
      desc: "",
      text1: "全新架构",
      text2: "全新四核处理器",
      text3: "支持多达12方通话",
    },
    apps1: {
      title: "在办公室",
      desc: "化身为多设备同步的小助手",
    },
    apps2: {
      title: "在大会议室",
      desc: "作为扬声器",
    },
    apps3: {
      title: "在中小会议室",
      desc: "作为会议电话",
    },
    apps4: {
      title: "在酒店",
      desc: "作为外放音箱",
    },
    apps5: {
      title: "居家办公",
      desc: "高效平衡工作和生活",
    },
  },
  rc: {
    name: "姓名*",
    country: "国家*",
    company: "公司",
    position: "职位",
    email: "邮箱*",
    phone: "手机*",
    contact: "联系我们",
    salesContact: "商务联系",
    technicalSupport: "技术支持",
    addr: "<p>上海市浦东新区纳贤路</p><p>60号1号楼2楼</p>",
    web: "www.aledevice.com/cn",
    weixin: "阿朗终端 ALE Device",
    register: "预约参会",
    submit: "提交",
    message: "可选:简要描述您的需求",
    Europe: "欧洲",
    NorthAmerica: "北美",
    China: "中国",
    OtherAPAC: "其它亚太地区",
    PleaseEnter: "请填写",
    contactInfo: "联系信息",
  },
  footer: {
    tabs1: "预约参会",
    tabs2: "M8桌面话机",
    tabs3: "联系我们",
  },
};
